<template>
  <div class="content-page" v-if="applitInfo">
    <div class="bd">
      <div class="content">
        <div class="content-container">
          <div style="padding: 20px">
            实际尺寸大小以选择的模板内图标大小为标准。不清楚模板内的图标尺寸大小建议100px至240px区间的正方形图标（圆角图标）。单个图标不超过3MB。
          </div>
          <el-form label-width="100px" style="padding: 20px 0">
            <div v-for="item in list" :key="item.id">
              <el-form-item :label="orderType[item.type].title">
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :file-list="item.iconArr"
                  :on-remove="handleRemove.bind(null, { data: item })"
                  :http-request="handleSuccess.bind(null, { data: item })"
                  :on-exceed="onExceedLimit"
                  :before-upload="beforeImgUpload"
                  :class="{ hide: item.iconArr.length == 1 }"
                  :limit="1"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCustomIconList, saveCustomIcon, uploadImg } from "@/api";
export default {
  data() {
    return {
      list: [
        { type: 1 },
        { type: 2 },
        { type: 3 },
        { type: 4 },
        { type: 5 },
        { type: 6 },
        { type: 7 },
        { type: 8 },
        { type: 9 },
        { type: 10 },
        { type: 11 },
        { type: 12 },
        { type: 13 },
        { type: 14 },
      ],
      customerIcon: [],
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      orderType: {
        1: {
          title: "特价限购",
        },
        2: {
          title: "砍价",
        },
        3: {
          title: "分销",
        },
        4: {
          title: "权益卡",
        },
        5: {
          title: "优惠券",
        },
        6: {
          title: "会员",
        },
        7: {
          title: "积分",
        },
        8: {
          title: "拼团",
        },
        9: {
          title: "快速买单",
        },
        10: {
          title: "直播",
        },
        11: {
          title: "扫码点餐",
        },
        12: {
          title: "堂食就餐",
        },
        13: {
          title: "外卖配送",
        },
        14: {
          title: "打包带走",
        },
      },
    };
  },
  computed: {
    ...mapState({
      applitInfo: (state) => state.applitInfo,
    }),
  },
  mounted() {
    this.getCustomIconList();
  },
  methods: {
    getCustomIconList() {
      getCustomIconList({
        pageNumber: 1,
        pageSize: 20,
      }).then((res) => {
        if (res.code == 1) {
          // let newArr = []
          // let teamArr = []
          // let listData = res.data.list
          // for (let i = 0; i < listData.length; i++) {
          //   if (!teamArr.includes(listData[i]['type'])) {
          //     newArr.push({
          //       // id: listData[i]['id'],
          //       type: listData[i]['type'],
          //       url: [{url:listData[i]}]
          //     })
          //     teamArr.push(listData[i]['type'])
          //   } else {
          //     for (let n = 0; n < newArr.length; n++) {
          //       if (newArr[n]['type'] == listData[i]['type']) {
          //         newArr[n].url.push({url:listData[i]})
          //         break
          //       }
          //     }
          //   }
          // }
          // this.list = newArr
          // console.log(newArr)

          this.list.forEach((v) => {
            // console.log(v, 'v')
            v.sonList = [];
            v.iconArr = [];
            res.data.list.forEach((n, index) => {
              if (v.type == n.type) {
                v.sonList.push(n);
                v.iconArr.push({
                  url: n.icon,
                  id: n.id,
                });
              }
            });
          });
          console.log(this.list, "list");
          this.$forceUpdate();
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onExceedLimit(files, fileList) {
      // console.log(files, "onExceedLimit")
      // console.log(fileList, "fileList")
      if (files.length >= 1) {
        this.$notify({
          title: "警告",
          message: "请先删除再上传照片",
          type: "warning",
          duration: 2000,
        });
      }
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleRemove(i, list) {
      // console.log(i, "handleRemove")
      // console.log(list, "list")
      // this.$confirm("您确定要删除该图片吗", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(({ value }) => {
      // this.hideUpload = fileList.length >= 1;
      saveCustomIcon({
        shopStoreId: localStorage.shopStoreId,
        type: i.data.type,
        icon: list.url,
        isDelete: 1,
        customIconId: list.id,
      }).then((res) => {
        if (res.code == 1) {
          this.getCustomIconList();
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
        }
      });
      // })
    },
    handleSuccess(e, item) {
      // console.log(item, "handleSuccess")
      // console.log(e, "e", e.data.type)
      // return
      let type = e.data.type;
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("icon", item.file.name);
      uploadImg(imgUploadForm).then((res) => {
        // console.log(res, res.data.url, 13256)
        // console.log(e, "e", e.data.type)
        if (res.code == 1) {
          let reg = /(https):\/\/([\w.]+\/?)\S*/gi;
          let icon = res.data.url;
          if (!icon.match(reg)) {
            this.$notify({
              title: "提示",
              message: "上传失败",
              type: "error",
              duration: 2000,
            });
            return;
          }
          saveCustomIcon({
            shopStoreId: localStorage.shopStoreId,
            type,
            icon,
          }).then((res1) => {
            if (res1.code == 1) {
              this.getCustomIconList();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px;
}
</style>
